/**
 * @generated SignedSource<<bac755f3ea2c0e3adbff74d5008c4eda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateInfluencerMutationInput = {
  allowNotification?: boolean | null;
  buildingName?: string | null;
  cityName?: string | null;
  clientMutationId?: string | null;
  firstName?: string | null;
  firstNameKana?: string | null;
  lastName?: string | null;
  lastNameKana?: string | null;
  phoneNumber?: string | null;
  postalCode?: string | null;
  prefectureName?: string | null;
  townName?: string | null;
};
export type AddressEditUpdateMutation$variables = {
  input: UpdateInfluencerMutationInput;
};
export type AddressEditUpdateMutation$data = {
  readonly updateInfluencer: {
    readonly __typename: "Influencer";
    readonly buildingName: string | null;
    readonly cityName: string | null;
    readonly postalCode: string | null;
    readonly prefectureName: string | null;
    readonly townName: string | null;
  } | {
    readonly __typename: "UpdateInfluencerError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type AddressEditUpdateMutation = {
  response: AddressEditUpdateMutation$data;
  variables: AddressEditUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prefectureName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cityName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "townName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buildingName",
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UpdateInfluencerError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddressEditUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddressEditUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8db9c38598fe10924abaa34741a38a5f",
    "id": null,
    "metadata": {},
    "name": "AddressEditUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AddressEditUpdateMutation(\n  $input: UpdateInfluencerMutationInput!\n) {\n  updateInfluencer(input: $input) {\n    __typename\n    ... on Influencer {\n      postalCode\n      prefectureName\n      cityName\n      townName\n      buildingName\n      id\n    }\n    ... on UpdateInfluencerError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5ebd27c8919a577935bdf0f42c12aca";

export default node;
